/**
 * Renders a single floor-plan card.
 * @param {Object} card - Floor-plan card data.
 * @returns {string} HTML string for one card.
 */
export function renderFloorPlanCard(card = {}) {
	const {
		imageAlt = card.name?.trim()
			? `${card.name.trim()} floor plan hero image`
			: 'floor plan hero image',
		lotLabel =  card.lotIds?.length ? 'Lot' : null,
		statusLabel = null,
	} = card;

	const lotCount = card.lotIds?.length ?? 0;
	const lotText = lotCount === 1 ? 'Lot' : 'Lots';
  const resolvedLotLabel = (lotLabel && lotCount > 0 && `${lotCount} ${lotText} Available`) || null;

	const lotBadgeHtml = resolvedLotLabel
		? `<div class="nhs-c-siteplan-card__badge">${resolvedLotLabel}</div>`
		: '';

	const statusBadgeHtml = statusLabel
		? `<div class="nhs-c-siteplan-card__badge nhs-c-siteplan-card__badge--available">${statusLabel}</div>`
		: '';
	const badgesHtml = lotBadgeHtml || statusBadgeHtml
		? `
			<div class="nhs-c-siteplan-card__badges" data-qa="native_ism_floorplan_badge">
				${lotBadgeHtml}
				${statusBadgeHtml}
			</div>
		`
		: '';

	return `
		<article class="nhs-c-siteplan-card" data-plan-id="${card.planId}" data-qa="native_ism_floorplan_card">
			<div class="nhs-c-siteplan-card__image-wrapper nhs-mq-siteplan-card__image-wrapper-medium">
				<img class="nhs-c-siteplan-card__image"
                    loading="lazy"
                    src="${card.image}"
                    alt="${imageAlt}" />
			</div>
			${badgesHtml}
			<div class="nhs-c-siteplan-card__content">
				<h4 class="nhs-c-siteplan-card__title" data-qa="native_ism_floorplan_title">${card.name}</h4>
				<p class="nhs-c-siteplan-card__price" data-qa="native_ism_floorplan_price">${card.formattedPrice}</p>
				<div class="nhs-c-siteplan-card__stats" data-qa="native_ism_floorplan_stats">
					<span class="nhs-c-siteplan-card__stat" aria-label="${card.bedrooms} Bedrooms"><b aria-hidden="true">${card.bedrooms}</b> Bd</span>
					<span class="nhs-c-siteplan-card__stat" aria-label="${card.formattedBathrooms} Baths"><b aria-hidden="true">${card.formattedBathrooms}</b> Ba</span>
					<span class="nhs-c-siteplan-card__stat" aria-label="${card.garage} Garage"><b aria-hidden="true">${card.garage}</b> Gr</span>
					<span class="nhs-c-siteplan-card__stat" aria-label="${card.formattedSquareFeet} Square Feet"><b aria-hidden="true">${card.formattedSquareFeet}</b> Sqft</span>
				</div>
			</div>
		</article>
	`;
}

/**
 * Renders the floor-plan cards grid.
 * @param {Object[]} cards - Floor-plan card list.
 * @returns {string} HTML string for the cards grid.
 */
export function renderFloorPlanGrid(cards = []) {
	const cardsHtml = cards.map(renderFloorPlanCard).join('');
	const gridClasses = [
		'nhs-c-native-interactive-site-map__card-grid',
		'nhs-mq-native-interactive-site-map__card-grid-medium',
		'nhs-mq-native-interactive-site-map__card-grid-large',
	];

	if (cards.length > 1) {
		gridClasses.push('nhs-c-native-interactive-site-map__card-grid--scroll');
	} else {
		gridClasses.push('nhs-c-native-interactive-site-map__card-grid--single');
	}

  return `
    <div class="${gridClasses.join(' ')}" data-qa="native_ism_floorplan_grid">
      ${cardsHtml}
    </div>
  `;
}
